<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="80px">
					<el-form-item label="所属团队" prop="teamId" v-if="roleId==2">
						<el-select v-model="queryParams.teamId" style="width: 100%;" placeholder="请选择团队">
							<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所属设备" prop="deviceId">
						<el-select v-model="queryParams.deviceId" ref="deviceSelect" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList"
							:loading="deviceLoading" @focus="deviceSelectFocus" :clearable="true">
							<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="处理状态">
						<el-select v-model="queryParams.status" placeholder="请选择处理状态">
							<el-option label="全部" value=""></el-option>
							<el-option label="未处理" :value="0"></el-option>
							<el-option label="已处理" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申请日期">
						<el-date-picker v-model="queryParams.createDates" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始时间"
							end-placeholder="结束时间" value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="title" label="求助描述"></el-table-column>
					<el-table-column prop="deviceTitle" label="关联设备"></el-table-column>
					<el-table-column prop="type" label="求助类型">
						<template slot-scope="scope">
							{{scope.row.type|formatType}}<br />
						</template>
					</el-table-column>
					<el-table-column prop="recipientProvinceCode" label="邮寄地址">
						<template slot-scope="scope">
							{{scope.row | formatAddress}}
						</template>
					</el-table-column>
					<el-table-column prop="trackingNumber" label="快递单号"></el-table-column>
					<el-table-column prop="creatorName" label="申请人"></el-table-column>
					<el-table-column prop="createTime" label="申请时间"></el-table-column>
					<el-table-column prop="status" label="处理状态">
						<template slot-scope="scope">
							{{scope.row.status | formatStatus}}
						</template>
					</el-table-column>
					<el-table-column prop="operatorName" label="处理人"></el-table-column>
					<el-table-column prop="operateTime" label="处理时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-if="scope.row.status==0" v-has="'btn_operator'">处理</el-button>
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)" v-else>查看</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog title="维护求助" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="90px" label-suffix=":">
				<el-form-item label="求助类型" prop="type">{{addOrUpdateForm.type | formatType}}</el-form-item>
				<el-form-item label="申请设备" prop="institutionId">{{addOrUpdateForm.deviceTitle}}</el-form-item>
				<el-form-item label="申请描述" prop="title">
					<el-input type="textarea" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.title" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="邮寄地址" v-if="addOrUpdateForm.type=='material_apply'">{{addOrUpdateForm|formatAddress}}</el-form-item>
				<el-form-item label="上传照片">
					<span class="el-descriptions-item__content">
						<div>
							<ul class="el-upload-list el-upload-list--picture-card">
								<li tabindex="0" class="el-upload-list__item is-success" v-for="(image,index) in addOrUpdateForm.imageList" :key="index">
									<el-image style="width: 80px; height: 80px" :src="image" fit="fit" :preview-src-list="addOrUpdateForm.imageList"></el-image>
								</li>
							</ul>
						</div>
					</span>
				</el-form-item>
				<el-form-item label="快递公司" prop="trackingNumber" v-if="addOrUpdateForm.type=='material_apply'">
					<el-select v-model="addOrUpdateForm.expressCompany" placeholder="请选择快递公司">
						<el-option label="顺丰速递" value="顺丰速递"></el-option>
						<el-option label="中通快递" value="中通快递"></el-option>
						<el-option label="圆通快递" value="圆通快递"></el-option>
					</el-select>
					<el-input type="text" v-model="addOrUpdateForm.trackingNumber" placeholder="请输入快递单号" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item label="处理结果" prop="description" v-else>
					<el-input type="textarea" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleOperator">确 定</el-button>
			</div>
		</el-dialog>


		<el-dialog title="工单详情" :visible.sync="dialogDetailVisible" width="800px" :close-on-click-modal="false">
			<el-row>
				<el-descriptions class="margin-top" :column="1" :labelStyle="label_style">
					<el-descriptions-item label="求助类型">
						{{addOrUpdateForm.type | formatType}}
					</el-descriptions-item>
					<el-descriptions-item label="申请设备">
						{{addOrUpdateForm.deviceTitle}}
					</el-descriptions-item>
					<el-descriptions-item label="申请描述">
						<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.title"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="邮寄地址" v-if="addOrUpdateForm.type=='material_apply'">
						{{addOrUpdateForm|formatAddress}}&nbsp;<el-button type="text" @click="copyText">复制</el-button>
					</el-descriptions-item>
					<el-descriptions-item label="上传照片">
						<span class="el-descriptions-item__content">
							<div>
								<ul class="el-upload-list el-upload-list--picture-card">
									<li tabindex="0" class="el-upload-list__item is-success" v-for="(image,index) in addOrUpdateForm.imageList" :key="index">
										<el-image style="width: 80px; height: 80px" :src="image" fit="fit" :preview-src-list="addOrUpdateForm.imageList"></el-image>
									</li>
								</ul>
							</div>
						</span>
					</el-descriptions-item>
					<el-descriptions-item label="快递公司" v-if="addOrUpdateForm.type=='material_apply'">
						{{addOrUpdateForm.expressCompany}}{{addOrUpdateForm.trackingNumber}}
					</el-descriptions-item>
					<el-descriptions-item label="申请设备">
						{{addOrUpdateForm.deviceTitle}}
					</el-descriptions-item>
					<el-descriptions-item label="申请设备">
						{{addOrUpdateForm.deviceTitle}}
					</el-descriptions-item>
					<el-descriptions-item label="处理人">
						{{addOrUpdateForm.operatorName}}
					</el-descriptions-item>
					<el-descriptions-item label="处理结果">
						<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
					</el-descriptions-item>
				</el-descriptions>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogDetailVisible = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		props: ['device'],
		data() {
			return {
				url: 'maintenance/help/order',
				name: '维护求助',
				deviceList: [],
				teamList: [],
				roleId: null,
				deviceLoading: false,
				queryDeviceParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				rules: {
					trackingNumber: [{
						required: true,
						message: '请填写快递单号',
						trigger: 'blur'
					}],
					description: [{
						required: true,
						message: '请输入处理结果',
						trigger: 'blur'
					}]
				},
				label_style: {
					'width': "100px", 
					'float': 'right',
					'text-align': 'right',
					'display': 'block',
					'word-break': 'break-all'
				},
				dialogDetailVisible: false
			};
		},
		filters: {
			formatAddress(data) {
				var address = "";
				if (data.recipientProvinceName) {
					address = data.recipientProvinceName;
				}
				if (data.recipientCityName) {
					address += data.recipientCityName;
				}
				if (data.recipientDistrictName) {
					address += data.recipientDistrictName;
				}
				if (data.recipientAddress) {
					address += data.recipientAddress;
				}
				return address
			},
			formatStatus(status) {
				if (status == 0) {
					return "未处理"
				} else if (status == 1) {
					return "已处理"
				}
			},
			formatType(type) {
				if (type == 'material_apply') {
					return '耗材申请'
				} else if (type == 'data_view') {
					return '数据可见'
				} else if (type == 'online_help') {
					return '线上协助'
				} else if (type == 'remote') {
					return '远程培训'
				} else if (type == 'analysis_apple') {
					return '分析申请'
				}
			}
		},
		methods: {
			handleDetail(row) {
				this.createUpdateForm(row);
				this.dialogDetailVisible = true;
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			beforeUpdate() {},
			beforeEdit() {
				if (!this.addOrUpdateForm.expressCompany) {
					this.addOrUpdateForm.expressCompany = "顺丰速递"
				}
			},
			queryDeviceList(query) {
				let that = this;
				this.deviceLoading = true;
				this.queryDeviceParams.title = query;
				this.$http({
					method: 'POST',
					url: 'devices/query',
					data: this.queryDeviceParams,
				}).then(function(res) {
					that.deviceList = res.data.data;
					that.deviceLoading = false
				})
			},
			deviceSelectFocus() {
				this.queryDeviceList()
			},
			handleOperator() {
				this.beforeValidate()
				//添加/保存
				this.$refs['addOrUpdateForm'].validate(valid => {
					if (valid) {
						this.beforeUpdate();
						let that = this;
						let url = '/operator';
						this.$http({
								method: 'POST',
								url: that.url + url,
								data: that.addOrUpdateForm
							})
							.then(function(res) {
								if (res.data.errorCode == '0000') {
									that.successMessage('系统提示', '操作成功');
									that.dialogVisible = false;
									that.getList();
								}
							})
					}
				});
			},
			queryTeamList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then(function(res) {
					that.teamList = res.data.data;
				})
			},
			copyText() {
				var data = this.addOrUpdateForm;
				var address = "";
				if (data.recipientProvinceName) {
					address = data.recipientProvinceName;
				}
				if (data.recipientCityName) {
					address += data.recipientCityName;
				}
				if (data.recipientDistrictName) {
					address += data.recipientDistrictName;
				}
				if (data.recipientAddress) {
					address += data.recipientAddress;
				}
				var that =this;
				navigator.clipboard.writeText(address)
					.then(() => {
						that.successMessage('系统提示', '复制成功');
					})
					.catch(err => {
						that.successMessage('系统提示', '复制失败' + err);
					});
			}
		},
		mounted: function() {
			if (this.device) {
				this.deviceList = [{
					id: this.device.id,
					title: this.device.title
				}]
				this.queryParams.deviceId = this.device.id
			}
			this.roleId = sessionStorage.getItem('_roleId');
			this.institutionId = sessionStorage.getItem('_institutionId');
			if (this.roleId == 2) {
				this.queryTeamList()
			}
			if (this.$route.query.teamId) {
				this.queryParams.teamId = this.$route.query.teamId;
			}
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	/deep/ .el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/order/maintenanceHelpOrder.vue